import { render, staticRenderFns } from "./list.vue?vue&type=template&id=ff9b6eb6&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=ff9b6eb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9b6eb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff9b6eb6')) {
      api.createRecord('ff9b6eb6', component.options)
    } else {
      api.reload('ff9b6eb6', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=ff9b6eb6&scoped=true&", function () {
      api.rerender('ff9b6eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/remoteGuidance/list.vue"
export default component.exports